import { IError } from '../../interfaces';

export function getErrorMessageToDisplay(error: IError): string {
    return error.type === 'Functional' ?
        error.message :
        'The server is not reachable, please sign in again later.';
}
